<script setup lang="ts">
export interface Props {
  isConfirmLoading?: boolean;
  confirm?: () => Promise<unknown>;
}
export type DefProps = typeof props;
const props = withDefaults(defineProps<Props>(), {
  isConfirmLoading: false,
  confirm: undefined,
});
const emit = defineEmits<{
  cancelBtnClick: [event: Event];
  confirmBtnClick: [event: Event, props: DefProps];
}>();

function handleCancelClick(event: Event): void {
  // also it should be wrapped with <v-dialog :persistent="isConfirmLoading"
  if (props.isConfirmLoading) return;
  emit('cancelBtnClick', event);
}

function handleConfirmClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('confirmBtnClick', event, props);
}
</script>

<template>
  <v-card :class="$style.logoutDialog" data-testid="logoutDialog">
    <v-card-title class="headline">Do you confirm logout?</v-card-title>
    <v-card-text> You will logout from web application </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" variant="text" @click="handleCancelClick">
        Cancel
      </v-btn>
      <v-btn color="blue darken-1" variant="text" @click="handleConfirmClick">
        Confirm
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.logoutDialog {
}
</style>
